/** @file Moves the project to the trash: the commit itself is the marker the ProjectDO pushes to D1. */
import { z } from 'zod';
import { defineCommand } from '../defineCommand';

export const command = defineCommand({
  name: 'project.trash',
  description: 'Move the project to the trash (reversible with project.restore; purge is UI-only).',
  input: z.object({}).strict(),
  apply(draft, input, ctx) {
    draft.meta.updatedAt = ctx.now;
  },
});
